<template>
<div>
    <el-button type="primary" @click="testing">test</el-button>
</div>
</template>

<script>
export default {
	name: 'testapi',
	components: {
    },
    methods:{
        testing()
        {
            var loginMethod = "common/getcustomerlist";
            //var loginMethod = 'LoginIn/Login'
            this.$axios.get(loginMethod,
                {
                    params:{
                        //tokenid :'FYgdh8EIQYSPQponSZldgVnmN5fH7rZg',
                        //account :'admin',
                        
                    },
                    headers:{
                        
                    },
                })
            .then((response) => {
                this.logining = false;
                if (true)//response.status == 200) 
                {
                    
                }
            })
            .catch(function (error) {
                console.log(error)
            }); 
        }
    },
}
</script>




// WEBPACK FOOTER //
// src/components/testapi.vue